import { makeVar } from '@apollo/client'

export const CATEGORY_ALL_ID = '55913279'
export const isPlayingState = makeVar(false)
export const isShowReelState = makeVar(true)
export const selectedFilter = makeVar(CATEGORY_ALL_ID)
